import identityResultError from "./identityResultError";

export default class identityResult {
    constructor(data: any) {
        Object.assign(this, data);
    }

    public succeeded: boolean = false;

    public errors: identityResultError[] = [];

    public getDescriptions() {
        let message = '';
        this.errors.forEach(error => {
            message += error.description + '\n';
        });
        return message;
    }
}